export enum FeedbackVariant {
	AFTER_AIFC_MODAL_CLOSE = 'after-aifc-modal-close',
	AFTER_UPDATE_STREAM_COMPLETE = 'after-update-stream-complete',
}
